import React, { useEffect, useState } from 'react'
import { Button, Grid, Paper, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import solicitacoesHistoricoRepository from './solicitacoesHistoricoRepository'
import { formatDateTime } from '../../utils/Validators'
import ViagensList from '../Solicitacoes/Viagens/ViagemList'

const styles = theme => ({
  root: {
    padding: 24
  },
  button: {
    marginTop: 8,
    marginBottom: 8
  },
  label: {
    display: 'inline-block',
    width: '100%'
  },
  value: {
    width: '100%',
    display: 'inline-block',
    wordWrap: 'break-word',
    overflow: 'hidden'
  }
})

const SolicitacoesHistorico = ({ classes, ...props }) => {
  const [item, setItem] = useState(null)

  useEffect(() => {
    const fetchData = async id => {
      if (id) {
        const response = await solicitacoesHistoricoRepository.getOne(id)
        if (response.ok) {
          setItem(response.data)
        }
      }
    }
    fetchData(props.match.params.id)
  }, [props.match.params.id])

  const LabelValue = ({ label, value }) => (
    <>
      {label && (
        <Typography variant="caption" className={classes.label}>
          {label}
        </Typography>
      )}
      <Typography variant="body1" className={classes.value}>
        {value}
      </Typography>
    </>
  )

  return item ? (
    <Paper className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={4}
      >
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                Informações
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue label="Data" value={formatDateTime(item.createdAt)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue label="Status" value={item.status} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue
                label="Mercadoria"
                value={item.mercadoria ? item.mercadoria.descricao : ''}
              />
            </Grid>
            {item.cliente && (
              <Grid item xs={12} sm={4}>
                <LabelValue label="Cliente" value={item.cliente} />
              </Grid>
            )}
            <Grid item xs={12} sm={4}>
              <LabelValue
                label="Origem"
                value={`${item.cidadeOrigem}/${item.estadoOrigem}`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue
                label="Destino"
                value={`${item.cidadeDestino}/${item.estadoDestino}`}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                Motorista
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue
                label="Nome"
                value={item.motorista ? item.motorista.nome : ''}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <LabelValue
                label="CPF"
                value={item.motorista ? item.motorista.cpf : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Viagens
              </Typography>
            </Grid>

            <Grid item xs={12}>
              {(item.motorista.quantidadeViagens ||
                item.motorista.destaquesViagens ||
                item.motorista.quantidadeUltimasViagens) && (
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <LabelValue
                      label="Quantidade"
                      value={
                        item.motorista ? item.motorista.quantidadeViagens : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <LabelValue
                      label="Destaques"
                      value={
                        item.motorista ? item.motorista.destaquesViagens : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <LabelValue
                      label="Últimas"
                      value={
                        item.motorista
                          ? item.motorista.quantidadeUltimasViagens
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <ViagensList viagens={item.motorista.viagens} detalhesMotorista />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid justifyContent="flex-end" container spacing={2}>
            <Grid item>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => props.history.goBack()}
                className={classes.button}
              >
                Voltar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  ) : null
}

export default withStyles(styles)(SolicitacoesHistorico)
